import React, { useState } from "react";

export const DialogContext = React.createContext();

function DialogProvider({ children }) {
  const [state, setState] = useState("");

  const value = React.useMemo(() => {
    return {
      state,
      setState,
    };
  }, [state, setState]);

  return (
    <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
  );
}

export default DialogProvider;
